<app-header></app-header>
<section class="home_main_sec">
    <div class="container">
        <div class="home_main">
            <div class="row">
                <div class="col-md-8">
                    <div class="home_main_left">
                        <div class="home_post_catg cmn_bdr_wh_bg desk_view">
                            <!-- Nav tabs -->
                            <ul class="nav nav-tabs slick_slider">
                                <li class="nav-item">
                                    <a class="nav-link active" (click)="setType('ALL')" data-toggle="tab" href="#all"> Articles </a>
                                </li>
                                <li class="nav-item">
                                    <a class="nav-link" data-toggle="tab" (click)="setType('YOGA')" href="#yoga"> Yoga Articles</a>
                                </li>
                                <li class="nav-item">
                                    <a class="nav-link" data-toggle="tab" (click)="setType('HEALTH')" href="#health"> Health Articles</a>
                                </li>
                               
                            </ul>

                            <div class="search-article mt-4"><input (keyup)="searchBlog()" [(ngModel)]="searchTerm" class="form-control" placeholder="Search Article.." type="text"></div>
                        </div>

                      

                        <div class="home_posts_container">
                            <!-- Tab panes -->
                            <div class="tab-content">
                                <div class="tab-pane active" id="all">
                                    <div class="home_posts-main">
                                        <div *ngFor="let article of articles" class="home_post_box_new home_posts_box cmn_bdr_wh_bg">
                                            
                                           
                                                <div class="home_posts_box_heading">
                                                      
                                                              
                                                         
                                                <div class="home_rightside_user_box">
                                                        <div class="home_rightside_user_box_img">
                                                                <a  class="partner-blog-box-downanchor" [routerLink]="['/blog-detail/'+article?.uniquekey]">
                                                                <img [src]="article.image" alt="">
                                                                </a>
                                                            </div>
                                                    <div class="home_rightside_user_box_cnt">
                                                        <h4>  {{ article?.title }}    </h4>
                                                        <p>  <a  class="partner-blog-box-downanchor" [routerLink]="['/doctors/detail/'+article?.doctorId?.uniquekey]">{{ article?.doctorId?.name }}</a>
                                                            , {{ article?.doctorId?.speciality.join(',') }}
                                                         </p>
                                                       <span>
                                                            <div style=" display: inline;" [innerHTML]="article?.text.length>100 ? article?.text.slice(0,100)+'...' : article?.text"></div>
                                                        <span ><a [routerLink]="['/blog-detail/'+article?.uniquekey]" style="cursor:pointer;    font-weight: 600;color: #02a7ff !important;"> 
                                                        
                                                            Read more
                                                        
                                                        </a></span>
                                                       </span> <!-- <a class="partner-blog-box-topanchor" [routerLink]="['/blog-detail/'+article?.uniquekey]">
                                                      <img [src]="article.image" alt="blog-box">
                                                    </a>  -->
                                                    </div>

                                                    <div class="home_posts_box_ftr">
                                                        <ul>
                                                            <li (click)="isLoggedIn ? like(article) : loginFirst(article)">
                                                                <a [routerLink]="null" [class]="article?.isLiked ? 'activeLike' : ''">
                                                                    <img  src="assets/images/heart.png" alt="">
                                                                    <span> {{ article?.likeCount ? article?.likeCount : 0 }} Likes </span>
                                                                </a>
                                                            </li>
                                                            <li>
                                                                <a [routerLink]="['/blog-detail/'+article?.uniquekey]">
                                                                    <img src="assets/images/chat-icon.png" alt="">
                                                                    <span> {{ article?.commentCount ? article?.commentCount : 0 }} Comments </span>
                                                                </a>
                                                            </li>
                                                            <li>
                                                                <a (click)="openShare(article)" [routerLink]="null">
                                                                    <img src="assets/images/share-icon.png" alt="">
                                                                    <span> Share </span>
                                                                </a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                   
                                                </div>
                                            </div>
                               
                                       
                                            <!-- <div class="home_posts_box_body">
                                                <img src="images/refer-img-1.png" alt="">
                                            </div> -->
                                          

                                        </div>
                                      
                                    </div>
                                </div>
                                <div class="tab-pane fade" id="yoga">
                                    <div class="home_posts-main">
                                            <div *ngFor="let article of yogaArticles" class="home_post_box_new home_posts_box cmn_bdr_wh_bg">
                                            
                                           
                                                    <div class="home_posts_box_heading">
                                                          
                                                                  
                                                             
                                                    <div class="home_rightside_user_box">
                                                            <div class="home_rightside_user_box_img">
                                                                    <a  class="partner-blog-box-downanchor" [routerLink]="['/blog-detail/'+article?.uniquekey]">
                                                                    <img [src]="article.image" alt="">
                                                                    </a>
                                                                </div>
                                                        <div class="home_rightside_user_box_cnt">
                                                            <h4>  {{ article?.title }}    </h4>
                                                            <p>  <a  class="partner-blog-box-downanchor" [routerLink]="['/doctors/detail/'+article?.doctorId?.uniquekey]">{{ article?.doctorId?.name }}</a>
                                                                , {{ article?.doctorId?.speciality.join(',') }}
                                                             </p>
                                                           <span>
                                                                <div style=" display: inline;" [innerHTML]="article?.text.length>100 ? article?.text.slice(0,100)+'...' : article?.text"></div>
                                                            <span ><a [routerLink]="['/blog-detail/'+article?.uniquekey]" style="cursor:pointer;    font-weight: 600;color: #02a7ff !important;"> 
                                                            
                                                                Read more
                                                            
                                                            </a></span>
                                                           </span> <!-- <a class="partner-blog-box-topanchor" [routerLink]="['/blog-detail/'+article?.uniquekey]">
                                                          <img [src]="article.image" alt="blog-box">
                                                        </a>  -->
                                                        </div>
    
                                                        <div class="home_posts_box_ftr">
                                                            <ul>
                                                                <li (click)="isLoggedIn ? like(article) : loginFirst(article)">
                                                                    <a [routerLink]="null" [class]="article?.isLiked ? 'activeLike' : ''">
                                                                        <img  src="assets/images/heart.png" alt="">
                                                                        <span> {{ article?.likeCount ? article?.likeCount : 0 }} Likes </span>
                                                                    </a>
                                                                </li>
                                                                <li>
                                                                    <a [routerLink]="['/blog-detail/'+article?.uniquekey]">
                                                                        <img src="assets/images/chat-icon.png" alt="">
                                                                        <span> {{ article?.commentCount ? article?.commentCount : 0 }} Comments </span>
                                                                    </a>
                                                                </li>
                                                                <li>
                                                                    <a (click)="openShare(article)" [routerLink]="null">
                                                                        <img src="assets/images/share-icon.png" alt="">
                                                                        <span> Share </span>
                                                                    </a>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                       
                                                    </div>
                                                </div>
                                   
                                           
                                                <!-- <div class="home_posts_box_body">
                                                    <img src="images/refer-img-1.png" alt="">
                                                </div> -->
                                              
    
                                            </div>
                                  

                                    </div>
                                </div>
                                <div class="tab-pane fade" id="health">
                                    <div class="home_posts-main">
                                            <div *ngFor="let article of healthArticles" class="home_post_box_new home_posts_box cmn_bdr_wh_bg">
                                            
                                           
                                                    <div class="home_posts_box_heading">
                                                          
                                                                  
                                                             
                                                    <div class="home_rightside_user_box">
                                                            <div class="home_rightside_user_box_img">
                                                                    <a  class="partner-blog-box-downanchor" [routerLink]="['/blog-detail/'+article?.uniquekey]">
                                                                    <img [src]="article.image" alt="">
                                                                    </a>
                                                                </div>
                                                        <div class="home_rightside_user_box_cnt">
                                                            <h4>  {{ article?.title }}    </h4>
                                                            <p>  <a  class="partner-blog-box-downanchor" [routerLink]="['/doctors/detail/'+article?.doctorId?.uniquekey]">{{ article?.doctorId?.name }}</a>
                                                                , {{ article?.doctorId?.speciality.join(',') }}
                                                             </p>
                                                           <span>
                                                                <div style=" display: inline;" [innerHTML]="article?.text.length>100 ? article?.text.slice(0,100)+'...' : article?.text"></div>
                                                            <span ><a [routerLink]="['/blog-detail/'+article?.uniquekey]" style="cursor:pointer;    font-weight: 600;color: #02a7ff !important;"> 
                                                            
                                                                Read more
                                                            
                                                            </a></span>
                                                           </span> <!-- <a class="partner-blog-box-topanchor" [routerLink]="['/blog-detail/'+article?.uniquekey]">
                                                          <img [src]="article.image" alt="blog-box">
                                                        </a>  -->
                                                        </div>
    
                                                        <div class="home_posts_box_ftr">
                                                            <ul>
                                                                <li (click)="isLoggedIn ? like(article) : loginFirst(article)">
                                                                    <a [routerLink]="null" [class]="article?.isLiked ? 'activeLike' : ''">
                                                                        <img  src="assets/images/heart.png" alt="">
                                                                        <span> {{ article?.likeCount ? article?.likeCount : 0 }} Likes </span>
                                                                    </a>
                                                                </li>
                                                                <li>
                                                                    <a [routerLink]="['/blog-detail/'+article?.uniquekey]">
                                                                        <img src="assets/images/chat-icon.png" alt="">
                                                                        <span> {{ article?.commentCount ? article?.commentCount : 0 }} Comments </span>
                                                                    </a>
                                                                </li>
                                                                <li>
                                                                    <a (click)="openShare(article)" [routerLink]="null">
                                                                        <img src="assets/images/share-icon.png" alt="">
                                                                        <span> Share </span>
                                                                    </a>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                       
                                                    </div>
                                                </div>
                                   
                                           
                                                <!-- <div class="home_posts_box_body">
                                                    <img src="images/refer-img-1.png" alt="">
                                                </div> -->
                                              
    
                                            </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
             


                <div class="col-md-4">
                        <div class="home_main_right">
                            <!-- <div class="home_rightside_user">
                                <div class="home_rightside_user_box">
                                    <div class="home_rightside_user_box_img">
                                        <img src="https://daktarz-assets.s3.ap-south-1.amazonaws.com/profilePic_1586094547442.jpg" alt="">
                                    </div>
                                    <div class="home_rightside_user_box_cnt">
                                        <h4> Robert Jones </h4>
                                        <p> robertjones </p>
                                    </div>
                                </div>
                            </div> -->
                            <div class="home_sponser_sidebar">
                                <div class="sponser_heading  cmn_bdr_wh_bg"> Featured Articles </div>
                                <div *ngFor="let article of featuredArticles" class="home_post_box_feature home_posts_box cmn_bdr_wh_bg">
                                            
                                           
                                        <div class="home_posts_box_heading">
                                              
                                                      
                                                 
                                        <div class="home_rightside_user_box">
                                                <div class="home_rightside_user_box_img">
                                                        <a  class="partner-blog-box-downanchor" [routerLink]="['/blog-detail/'+article?.uniquekey]">
                                                        <img [src]="article.image" alt="">
                                                        </a>
                                                    </div>
                                            <div class="home_rightside_user_box_cnt">
                                                <h4>  {{ article?.title }}    </h4>
                                                <p>  <a  class="partner-blog-box-downanchor" [routerLink]="['/doctors/detail/'+article?.doctorId?.uniquekey]">{{ article?.doctorId?.name }}</a>, {{ article?.doctorId?.speciality.join(',') }} </p>
                                               <!-- <span>
                                                <read-more [text]="article?.text" [maxLength]="100" [showToggleButton]="true"></read-more>
                                               </span>  -->
                                               
                                               <!-- <a class="partner-blog-box-topanchor" [routerLink]="['/blog-detail/'+article?.uniquekey]">
                                              <img [src]="article.image" alt="blog-box">
                                            </a>  -->
                                            </div>

                                            <div class="home_posts_box_ftr">
                                                <ul>
                                                    <li (click)="isLoggedIn ? like(article) : loginFirst(article)">
                                                        <a [routerLink]="null" [class]="article?.isLiked ? 'activeLike' : ''">
                                                            <img  src="assets/images/heart.png" alt="">
                                                            <span> {{ article?.likeCount ? article?.likeCount : 0 }}  </span>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a [routerLink]="['/blog-detail/'+article?.uniquekey]">
                                                            <img src="assets/images/chat-icon.png" alt="">
                                                            <span> {{ article?.commentCount ? article?.commentCount : 0 }}  </span>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a (click)="openShare(article)" [routerLink]="null">
                                                            <img src="assets/images/share-icon.png" alt="">
                                                            <span> Share </span>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                           
                                        </div>
                                    </div>
                       
                               
                                    <!-- <div class="home_posts_box_body">
                                        <img src="images/refer-img-1.png" alt="">
                                    </div> -->
                                

                                </div>
                            </div>
                        </div>
                        </div>
                



            </div>
        </div>
    </div>
</section>








<input type="hidden" id="share_trigger" data-toggle="modal" data-target="#share_modal">
<!-- The Modal -->
<div class="modal fade" id="share_modal">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
            <input type="text" style="position:relative;padding-right: 80px !important;" class="form-control" [(ngModel)]="blogData.url" #inputTarget />
 
            <button class="copy-text" [ngxClipboard]="inputTarget">Copy</button>

      <!-- Modal body -->
      <div class="modal-body">
        Share Via
        <share-buttons [title]="blogData.title" [image]="blogData.image" [url]="blogData.url" [include]="include"></share-buttons>
      </div>
    </div>
  </div>
</div>